export default "__VITE_ASSET__D7ypkeAE__$_?height=200&width=300__"